import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Dialog from '~/components/Dialog'
import { Nullable } from '~/types'
import { handleErrors } from '~/utils/helpers'
import { FarmersService } from '~/api/services/farmers'
import ResultsModal from '../../ClimateCheck/ResultsClimateCheck/ResultsModal'
import ClimaCheckService from '~/api/services/climaCheck'

interface Props {
  id: Nullable<string>
  handleClose: () => void
  uniqueId: Nullable<string>
  farmerId: string
}

const PreviewModal: React.FC<Props> = (props) => {
  const { id, handleClose, uniqueId, farmerId } = props
  const { t } = useTranslation()

  const [submitPreviewData, setSubmitPreviewData] = useState(null)
  const [isBusy, setIsBusy] = useState(false)

  useEffect(() => {
    if (id) {
      fetchPreviewData()
    }
  }, [id])

  async function fetchPreviewData() {
    setIsBusy(true)
    try {
      const response = await ClimaCheckService.getClimaChDairyResults(id, farmerId)
      setSubmitPreviewData(response.data)
    } catch (error) {
      handleErrors(error)
    }
    setIsBusy(false)
  }

  return <Dialog
    isDialogOpen={Boolean(id) && submitPreviewData}
    isLoading={isBusy}
    style={{ width: '80%' }}
    textHeader={t('GHG emission results for data collection {{id}}', { id: uniqueId })}
    textContent={<>
      {!isBusy && <ResultsModal results={submitPreviewData} removeMargin />}
    </>}
    handleClose={() => handleClose()}
    textClose={t('Close')}
  />

}
export default PreviewModal